import React, { useContext } from 'react';
import { Card } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import './index.scss';

export default function NotSynced() {
  return (<Container className="not-synced">
    <Card>
      <b>Please notice</b>: the analytics shown in the app on Arbitrum are currently not in sync with on-chain data.<br/>
      Check our vfat.tool page to see <a target="_blank" href="https://yield.impermax.finance/arbitrum/impermax/">live analytics</a>.
    </Card>
  </Container>);
}